import React, { useEffect, useState } from "react"
import { cn } from "lib/utils"
import { useRenderStyling } from 'lib/hooks/useRenderStyling';
import { parseContent, parseContentGroup } from "./utils"

export default function TopbarRender({ renderPkg }:{ renderPkg?:any }){

  const [ contentPkg, setContentPkg ] = useState<any>(null)

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "topbar").settings || {}
  const outerStyling = useRenderStyling("w-full flex flex-row justify-between items-center h-6 border border-solid border-neutral-700 text-xs pl-2 pr-2", "styleObj")


  const renderOptions = {
    standard_topbar_v1: {
      description: "Returns the merchant name at the left side and the case ID at the right side.",
      render: () => (
        <div className="w-full flex flex-row justify-between items-center gap-2">
          <span>{ contentPkg?.merchant }</span>
          <span>Case No &mdash; { contentPkg?.case_id }</span>
        </div>
      )
    }
  }


  useEffect(() => {
    const contentGroup = [
      { key: "merchant", content: "[[merchant.DBA]]" },
      { key: "case_id", content: "[[rp.Chargeback.ProcessorCaseId]]" },
    ]
    const parsed = parseContentGroup({ group: contentGroup, clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata })
    setContentPkg(parsed)
  },[])

  // useEffect(() => {
  //   console.log(parseContent({ content: "[[merchant.DBA]]", clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata}))
  // },[])

  return(
    <div id="mm-topbar" {...outerStyling}>
      <span>{ contentPkg?.merchant }</span>
      <span>Case No &mdash; { contentPkg?.case_id }</span>
    </div>
  )
}